import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import { NekoLogo } from './Logo';
import { NekoIcon } from './Icon';
import Theme from '../common/NekoTheme';
import contentSave from '@iconify/icons-mdi/content-save';

const HeaderBase = Styled.div`
  position: relative;
  color: white;
  font-family: ${Theme.fontFamily};
  font-size: ${Theme.fontSizeText};
  display: flex;
  height: 61px;
  overflow: hidden;
  align-items: center;
  padding: 15px 20px;
  background-color: var(--block-background);
  display: flex;

  .neko-header-logo-container {
    width: 102px;
    height: 102px;
    padding: 20px;
    margin-right: 25px;
    background: rgba(var(--neko-black-rgb), 0.1);
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(-29.83deg);
  }

  .neko-header-title-container {
    flex-direction: column;
    display: flex;

    .neko-header-title {
      color: white;
      font-family: ${Theme.fontFamily};
      font-size: 23px;
      line-height: normal;
      margin: 0;
    }

    .neko-header-subtitle {
      color: white;
      font-family: ${Theme.fontFamily};
      line-height: normal;
      font-size: ${Theme.fontSizeText};
    }
  }

  .neko-header-extra-content {
    flex: 1;
    margin: 0 20px;
  }
`;

const StyledNekoHeader = props => {

  const { title = 'NekoUI', subtitle = 'By Jordy Meow', children, saving = false } = props;

  return (
    <HeaderBase className='neko-header'>
      <div className='neko-header-logo-container'>
        <NekoLogo />
      </div>
      <div className="neko-header-title-container">
        <h1 className="neko-header-title">{title}</h1>
        <small className="neko-header-subtitle"><a target='_blank' href='https://meowapps.com' 
          style={{ color: 'white', textDecoration: 'none' }}>{subtitle}</a></small>
      </div>
      <div className="neko-header-extra-content">{children}</div>
      {saving && <NekoIcon icon={contentSave} width="36" height="36" />}
    </HeaderBase>
  );
};

const NekoHeader = (props) => {
  return (<StyledNekoHeader {...props} />);
}

NekoHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  saving: PropTypes.bool
};

NekoHeader.defaultProps = {
  title: 'NekoUI',
  subtitle: 'By Jordy Meow',
  saving: false
};

export { NekoHeader };
